module.exports = "data:application/x-tgif;base64,IyBCbGVuZGVyIHYyLjc5IChzdWIgMCkgT0JKIEZpbGU6ICdzaW11bGF0aW9uLTEuYmxlbmQnCiMgd3d3LmJsZW5kZXIub3JnCnYgMS42NTMwMjUgMC4wNDAxNzUgLTMuNTg0NjY2CnYgMS42NTMwMjMgMC4wNDAxNzUgMi45MDI5MTMKdiAtMS42NTMwMzAgMC4wNDAxNzUgMi45MDI5MTMKdiAtMS42NTMwMTQgMC4wNDAxNzUgLTMuNTg0NjY4CmwgMiAzCmwgMyA0CmwgNCAxCmwgMSAyCg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/models/simulation-area.obj
// module id = JzSN
// module chunks = 1